import { auth } from 'helpers/firebase';
import { SET_CURRENT_USER } from 'actions';
import { SET_CURRENT_ROLE } from 'actions';
import { ROLES } from 'constants/user';

const initState = {
  currentUser: null,
  currentRole: null,
}

export default function (state = initState, action) {
  switch (action.type) {

    case SET_CURRENT_USER: {
      return {
        ...state,
        currentUser: action.payload
      }
    }

    case SET_CURRENT_ROLE: {
      return {
        ...state,
        currentRole: action.payload
      }
    }

    default:
      return state
  }
}